module.exports = fox._r("images/default/gift-90.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/default/gift-90.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/default/gift-90.png
// module id = 291
// module chunks = 4